import './App.css';
// import Login from './components/login/login'
import 'primeicons/primeicons.css';
import { useState, useEffect } from 'react';
import NavContext from './contexts/NavContext';
import RouterComponent from './Router';
import { CartProvider } from './contexts/CartContext'; // مسیر درست فایل را جایگزین کنید
import NotificationHandler from './components/custom/notification-handler';
// index.js یا App.jsx
import '@fortawesome/fontawesome-free/css/all.min.css';


const App = () => {
  const [nav, setNav] = useState('');
  const value = { nav, setNav };
  useEffect(() => {
    const handleResize = () => {
        const height = window.innerHeight;
        document.body.classList.toggle('keyboard-active', window.innerHeight < height);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
}, []);
  return (
    <NavContext.Provider value={value}>
      <NotificationHandler />
      <CartProvider>
        <RouterComponent />
      </CartProvider>
    </NavContext.Provider>
  );

 
}

export default App;
